'use client'

import { useState } from 'react'
import { MdLock, MdVisibility, MdVisibilityOff } from 'react-icons/md'

interface Props {
    value: string
    onChange: (v: string) => void
    disabled?: boolean
    autoFocus?: boolean
    label?: string
}

export default function PasswordField({ value, onChange, disabled, autoFocus, label = 'Confirme sua senha' }: Props) {
    const [show, setShow] = useState(false)
    return (
        <div className="flex flex-col gap-1">
            <span className="text-sm font-medium text-base-content/80 flex items-center gap-1">
                <MdLock className="text-warning" /> {label}
            </span>
            <div className="relative">
                {/*
                 * `autoComplete="new-password"`, nunca `current-password`: esta
                 * senha confirma uma ação de dinheiro, não faz login. Declará-la
                 * como senha de login pedia ao navegador exatamente as duas
                 * coisas que não se quer aqui — preencher o campo sozinho, o que
                 * anula a confirmação (a ideia é provar que a pessoa está ali), e
                 * tratar o fechamento do formulário como um login, oferecendo
                 * "salvar senha" a cada aprovação. `off` não basta: o Chrome o
                 * ignora num campo de senha e ainda pré-preenchia esta senha e o
                 * campo de texto anterior (a descrição) com o e-mail salvo.
                 */}
                <input
                    type={show ? 'text' : 'password'}
                    className="input input-bordered input-sm w-full pr-9"
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    disabled={disabled}
                    autoFocus={autoFocus}
                    autoComplete="new-password"
                />
                <button
                    type="button"
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-base-content/50 hover:text-base-content"
                    onClick={() => setShow(s => !s)}
                    tabIndex={-1}
                >
                    {show ? <MdVisibilityOff /> : <MdVisibility />}
                </button>
            </div>
        </div>
    )
}
